import React from 'react';
import { motion } from 'framer-motion';
export function PositioningStrip() {
  return <section className="py-12 sm:py-20 lg:py-24 bg-white border-t border-gray-100" data-id="element-189">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-191">
          <p className="text-xl sm:text-2xl lg:text-4xl font-extrabold text-gray-900 leading-tight tracking-tight" data-id="element-192">
            Sin apps nuevas. Sin capacitación.
            <span className="block text-blue-600 mt-3 sm:mt-4" data-id="element-193">
              La mejor app de obra es la que nadie tiene que aprender.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}